<template>
  <mds-tabs>
    <mds-tabs-item
      v-for="(tab, index) in tabs"
      :key="index"
      :active="tab.isActive"
      @mds-tabs-item-active="$emit('tabClick', tab)"
    >
      {{ translate(tab.name) }}
    </mds-tabs-item>
  </mds-tabs>
</template>

<script>
import { MdsTabs, MdsTabsItem } from '@mds/tabs'
import MwcBaseHelpersMixin from '@morningstar/mcl-utilities/src/vue/mixins/mwc-base-mixin'
import defaultConfig from './config/i18n'

export default {
  name: 'FlyoverTabs',
  components: {
    MdsTabs,
    MdsTabsItem,
  },
  mixins: [MwcBaseHelpersMixin],
  props: {
    tabs: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      defaultConfig,
    }
  },
}
</script>
